import PropTypes from 'prop-types';

import React, { Component } from 'react';
import VideoPlayer from '../../../../../components/VideoPlayer';

export default class VideoCardPlayerDark extends Component {
  static propTypes = {
    card: PropTypes.object.isRequired
  };

  videoEndedEvent = () => {
    this.props.videoEndedEvent && this.props.videoEndedEvent();
  };

  render() {
    return (
      <div style={styles.container}>
        <div
          id="_channelVideoCardVideoContainer_"
          onClick={e => {
            e.stopPropagation();
          }}
          style={styles.flexFullWidth}
        >
          <VideoPlayer
            useEventsHelper={false}
            videoUrl={this.props.card.url}
            thumbUrl={this.props.card.webThumbUrl}
            onEndEvent={this.videoEndedEvent}
            autoPlay={true}
          />
        </div>
      </div>
    );
  }
}

const styles = {
  container: {
    display: 'flex',
    width: '100%',
    justifyContent: 'center',
    height: '100%'
  },
  videoStyle: {
    maxWidth: '100%',
    height: 'auto',
    width: '100%'
  },
  flexFullWidth: {
    width: '960px',
    display: 'flex',
    flexDirection: 'column',
    position: 'relative',
    height: '545px',
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: '40px'
  }
};
